<section
  [id]="id()"
  class="section-wrapper"
  [class.section-wrapper--surface]="background() === 'surface'"
  [class.section-wrapper--dark]="background() === 'dark'"
  [class.section-wrapper--accent]="background() === 'accent'"
>
  <div class="container" [class.container--narrow]="narrow()">
    @if (title()) {
      <div class="section-header" [class.section-header--left]="titleAlign() === 'left'">
        @if (eyebrow()) {
          <span class="section-eyebrow">{{ eyebrow() }}</span>
        }
        <h2 class="section-title">{{ title() }}</h2>
        @if (subtitle()) {
          <p class="section-subtitle">{{ subtitle() }}</p>
        }
      </div>
    }
    <ng-content />
  </div>
</section>
